import React, { useState } from "react";
import Highcharts from "highcharts";
import "highcharts/highcharts-more";
import HighchartsReact from "highcharts-react-official";
import { ChevronDown, ThermometerSun } from "lucide-react";
import clsx from "clsx";

const EngineSFOCGraph = ({ sfocEfficiency }) => {
  console.log("sfocEfficiency", sfocEfficiency);
  const [isOpen, setIsOpen] = useState(true);

  // Backend already gives [power, sfoc] pairs
  const actualData = sfocEfficiency || [];
  // const actualData = sfocEfficiency.map(([power, sfoc]) => [power * 100, sfoc]) || [];

  const options = {
    chart: {
      backgroundColor: "transparent",
      zoomType: "x",
    },
    title: {
      text: null,
    },
    xAxis: {
      title: { text: "Power (%)", style: { color: "#0a2540" } },
      labels: { style: { color: "#0a2540" } },
      tickInterval: 10,
      startOnTick: true,
      endOnTick: true,
      gridLineColor: "#e2e8f0",
      plotLines: [
        { color: "#cbd5e1", width: 1, value: 50, dashStyle: "Dash" },
        { color: "#cbd5e1", width: 1, value: 80, dashStyle: "Dash" },
      ],
    },
    yAxis: {
      title: { text: "SFOC (g/kWh)", style: { color: "#0a2540" } },
      labels: { style: { color: "#0a2540" } },
      gridLineColor: "#f1f5f9",
    },
    tooltip: {
      shared: false,
      crosshairs: true,
      valueSuffix: " g/kWh",
      backgroundColor: "#fff",
      borderColor: "#94a3b8",
      borderRadius: 8,
      style: { color: "#0a2540" },
      formatter: function () {
        return `Power: <b>${this.x.toFixed(2)}%</b><br/>SFOC: <b>${this.y.toFixed(2)} g/kWh</b>`;
      },
    },
    series: [
      {
        name: "SFOC Actual",
        type: "areaspline",
        data: actualData,
        color: {
          linearGradient: [0, 0, 0, 300],
          stops: [
            [0, "#0a2540"],
            [1, "rgba(14,165,233,0.1)"],
          ],
        },
        fillOpacity: 0.3,
        lineWidth: 2.5,
        marker: {
          enabled: true,
          radius: 4,
          fillColor: "#0a2540",
          lineColor: "#0a2540",
        },
      },
    ],
    credits: { enabled: false },
    legend: { enabled: false },
  };

  return (
    <div className="w-full rounded-md bg-white overflow-hidden shadow-xl backdrop-blur-md transition-all duration-300">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-gradient-to-br from-[#1a325d] to-[#12213f] w-full flex items-center justify-between px-4 py-3 text-left focus:outline-none group"
      >
        <div className="flex items-center gap-3">
          <div className="text-blue-400 transition-all duration-300">
            <ThermometerSun size={20} strokeWidth={2} />
          </div>
          <h3 className="text-[15px] font-semibold text-white tracking-wide">
            SFOC
          </h3>
        </div>

        <ChevronDown
          className={clsx(
            "w-5 h-5 text-white transition-transform duration-300",
            isOpen && "rotate-180"
          )}
        />
      </button>

      <div
        className={clsx(
          "transition-all duration-500 ease-in-out overflow-hidden",
          isOpen ? "max-h-[1000px] py-4 px-4" : "max-h-0 py-0 px-4"
        )}
      >
        {isOpen && <HighchartsReact highcharts={Highcharts} options={options} />}
      </div>
    </div>
  );
};

export default EngineSFOCGraph;

